import { Outlet } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';
import { TopBar } from '@/components/layout/TopBar';
import { VisitorNavbar } from '@/components/layout/VisitorNavbar';
// We might need sidebar for logged in users? 
// Wait, TopBar usually goes with Sidebar in DashboardLayout. 
// If we just use TopBar here, it might look weird without sidebar if TopBar expects it.
// However, the requirement is "If visitor is logged in: render normal user navbar".
// Let's assume for now we just want the TopBar for the logged-in feeling, 
// OR we should perhaps redirect/render the DashboardLayout structure?
// The prompt says "render normal user navbar", which implies TopBar.

export const PublicLayout = () => {
    const { currentUser } = useAuth();
    // const currentUser = null; // FORCE GUEST MODE FOR VERIFICATION

    // If logged in, we want the TopBar. 
    // We also need to adjust padding because TopBar is fixed.

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-black">
            {currentUser ? (
                <>
                    <TopBar />
                    <div className="pt-16">
                        <Outlet />
                    </div>
                </>
            ) : (
                <>
                    <VisitorNavbar />
                    <main>
                        <Outlet />
                    </main>
                </>
            )}
        </div>
    );
};
